/* tslint:disable:max-line-length */
import {Injectable} from '@angular/core';
import {filter, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';
import {MmProjectLoaderService} from '../../mm-project/mm-project-loader.service';
import {Logger} from '@mydocma/common/src/lib/logger';


@Injectable()
export class DelayService {

  private readonly delayCacheImage = new Map<number, Observable<Blob>>();
  delays$ = this.projectLoaderService.delays.pipe(filter(userPerm => userPerm.loadState.status == LoadStatusEnum.Loaded), map(m => m.data));

  constructor(private readonly projectLoaderService: MmProjectLoaderService,
              private readonly logger: Logger) {
  }

  getDelayImage(delayId: number) {
    if (this.delayCacheImage.get(delayId) === undefined) {
      const delay = this.delays$.pipe(map(m => m.filter(f => f.Id === delayId)[0]), map(m => (m?.DelayImage ? new Blob([m.DelayImage]) : undefined) ));
      if (delay) {
        this.delayCacheImage.set(delayId, delay);
      }
      else {
        this.logger.error('Delay image (' + delayId + ') not found', '', 'DelayService');
      }
    }
    return this.delayCacheImage.get(delayId);
  }
}
